import styled from 'styled-components'

export const TableRow = styled.tr`
  vertical-align: baseline;
`
